import { useMsal } from '@azure/msal-react';

export const useAuth = () => {
  const { instance, accounts } = useMsal();

  const login = () => {
    instance.loginPopup();
  };

  const logout = () => {
    instance.logoutRedirect();
  };

  const isAuthenticated = accounts.length > 0;
  const user = accounts[0];

  return {
    login,
    logout,
    isAuthenticated,
    user,
    accounts
  };
};
